import AppTextField from "@/components/AppTextField";
import AppLoadingButton from "@/components/mui/LoadingButton";
import API from "@/constant/API";
import axiosInstance from "@/utils/axios";
import {Box, IconButton, InputAdornment} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import classes from "@/pages/security/css/index.module.less";
import RpIcon from "@/components/RpIcon";
import {enqueueSnackbar} from "notistack";
import SimpleHeader from "../components/Headers/SimpleHeader";
import PasswordInput from "@/components/PasswordInput";

function UpdatePw() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [passwordMatchError, setPasswordMatchError] = useState('');
  const [loading, setLoading] = useState(false);

  const [visiblePassword1, setVisiblePassword1] = useState(false);
  const [visiblePassword2, setVisiblePassword2] = useState(false);
  const [visiblePassword3, setVisiblePassword3] = useState(false);

  const handleTogglePasswordVisibility = (field) => {
    if (field === 'password1') {
      setVisiblePassword1((prev) => !prev);
    } else if (field === 'password2') {
      setVisiblePassword2((prev) => !prev);
    } else if (field === 'password3') {
      setVisiblePassword3((prev) => !prev);
    }
  };
  
  const handleSubmit = async (evt) => {
    evt.preventDefault();
    if (password !== passwordConfirm) {
      setPasswordMatchError(t('passwords_do_not_match'));
      return;
    }
    setPasswordMatchError(''); // Clear any previous errors
    // TODO: 提示用户24小时内不可提现 消费限制在1000 usd， 确认后执行修改
    try {
      setLoading(true);
      await axiosInstance.post(API.UPDATE_PW, {
        password: oldPassword,
        newPassword: password,
      });
      // TODO: toast 提示用户修改密码成功
      enqueueSnackbar(t('update_password_successful'), { variant: 'success' })
      navigate(-1);
    } finally {
      setLoading(false);
    }
  }

  return (<>
    <SimpleHeader />
    <Box className={classes["security-wrap"]}>
      <Box className={classes["security-title-wrap"]}>
        <div className={classes["security-title"]}>{t('update_pw')}</div>
      </Box>
      <Box className={classes["security-alert"]}>
        <RpIcon icon="info" size={22} />
        <p>{t('reset_pw_alert')}</p>
      </Box>
      <form autoComplete="off" onSubmit={handleSubmit}>
        {/* TODO 新密码和密码确认匹配判断 */}
        <Box className={classes["column-gap-wrap"]}>
          <AppTextField
            label={t('old_password')}
            placeholder={t('old_password')}
            onChange={(e) => setOldPassword(e.target.value)}
            required
            value={oldPassword}
            fullWidth
            autoComplete="off"
            // clearable
            // onClear={() => setOldPassword('')}
            type={visiblePassword1 ? 'text' : 'password'}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => handleTogglePasswordVisibility('password1')}
                    edge="end"
                  >
                    {visiblePassword1 ? (
                      <RpIcon icon="eye_open" size={22} />
                    ) : (
                      <RpIcon icon="eye_close" size={22} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {/*<AppTextField*/}
          {/*  label={t('new_password')}*/}
          {/*  placeholder={t('new_password')}*/}
          {/*  onChange={(e) => setPassword(e.target.value)}*/}
          {/*  required*/}
          {/*  value={password}*/}
          {/*  fullWidth*/}
          {/*  autoComplete="off"*/}
          {/*  // clearable*/}
          {/*  // onClear={() => setPassword('')}*/}
          {/*  type={visiblePassword2 ? 'text' : 'password'}*/}
          {/*  InputProps={{*/}
          {/*    endAdornment: (*/}
          {/*      <InputAdornment position="end">*/}
          {/*        <IconButton*/}
          {/*          aria-label="toggle password visibility"*/}
          {/*          onClick={() => handleTogglePasswordVisibility('password2')}*/}
          {/*          edge="end"*/}
          {/*        >*/}
          {/*          {visiblePassword2 ? (*/}
          {/*            <RpIcon icon="visible" size={22} />*/}
          {/*          ) : (*/}
          {/*            <RpIcon icon="invisible" size={22} />*/}
          {/*          )}*/}
          {/*        </IconButton>*/}
          {/*      </InputAdornment>*/}
          {/*    ),*/}
          {/*  }}*/}
          {/*/>*/}
          <PasswordInput
            label={t('new_password')}
            placeholder={t('new_password')}
            onChange={(e) => setPassword(e.target.value)}
            required
            value={password}
            fullWidth
            autoComplete="off"
          />
          <AppTextField
            label={t('new_password_confirm')}
            placeholder={t('new_password_confirm')}
            onChange={(e) => setPasswordConfirm(e.target.value)}
            required
            value={passwordConfirm}
            fullWidth
            autoComplete="off"
            // clearable
            // onClear={() => setPasswordConfirm('')}
            type={visiblePassword3 ? 'text' : 'password'}
            error={!!passwordMatchError}
            helperText={passwordMatchError}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => handleTogglePasswordVisibility('password3')}
                    edge="end"
                  >
                    {visiblePassword3 ? (
                      <RpIcon icon="eye_open" size={22} />
                    ) : (
                      <RpIcon icon="eye_close" size={22} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </form>
      <Box className={classes["fixed-button"]}>
        <AppLoadingButton
          fullWidth
          loading={loading}
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          onClick={handleSubmit}
        >
          {t('confirm')}
        </AppLoadingButton>
      </Box>
    </Box>
  </>);
}

export default UpdatePw;
